import { useEffect } from 'react'

const useSwipe = (element, { onRight, onLeft, onUp, onDown }, deps = []) => {
  let touchstartX = 0
  let touchstartY = 0
  let touchendX = 0
  let touchendY = 0

  const limit = Math.tan(((30 * 1.5) / 180) * Math.PI) // allow 30 degree swipe
  const swipeMinLength = 50 // allow swipe length of min 50px

  useEffect(() => {
    if (element === null || typeof element === 'undefined') return

    const handleSwipe = () => {
      const x = touchendX - touchstartX
      const y = touchendY - touchstartY
      const xy = Math.abs(x / y)
      const yx = Math.abs(y / x)
      let swipeDirection = ''

      if (yx <= limit && Math.abs(x) > swipeMinLength) {
        swipeDirection = x < 0 ? 'left' : 'right'
      }
      if (xy <= limit && Math.abs(y) > swipeMinLength) {
        swipeDirection = y < 0 ? 'up' : 'down'
      }

      if (swipeDirection === 'left') {
        onLeft && onLeft()
      }
      if (swipeDirection === 'right') {
        onRight && onRight()
      }
      if (swipeDirection === 'up') {
        onUp && onUp()
      }
      if (swipeDirection === 'down') {
        onDown && onDown()
      }
    }

    const handleTouchStart = (evt) => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      touchstartX = evt.changedTouches[0].screenX
      // eslint-disable-next-line react-hooks/exhaustive-deps
      touchstartY = evt.changedTouches[0].screenY
    }

    const handleTouchEnd = (evt) => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      touchendX = evt.changedTouches[0].screenX
      // eslint-disable-next-line react-hooks/exhaustive-deps
      touchendY = evt.changedTouches[0].screenY
      handleSwipe()
    }

    element.addEventListener('touchstart', handleTouchStart, false)

    element.addEventListener('touchend', handleTouchEnd, false)

    return () => {
      element.removeEventListener('touchstart', handleTouchStart)
      element.removeEventListener('touchend', handleTouchEnd)
    }
  }, [...deps, element])
}

export default useSwipe
